import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IframeModalComponent } from 'src/app/shared-new/components/iframe-modal/iframe-modal.component';

@Component({
  selector: 'app-sale-terms-condition-popup',
  templateUrl: './sale-terms-condition-popup.component.html',
  styleUrls: ['./sale-terms-condition-popup.component.scss'],
})
export class SaleTermsConditionPopupComponent implements OnInit {
  @Input() public data: any;

  constructor(
    public readonly modal: NgbActiveModal,
    private modalService: NgbModal,
    private domSanitizer: DomSanitizer
  ) {}

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }

  public ngOnInit(): void {}

  openPDF(url: string): void {
    const pdfURL = url;
    const modalRef = this.modalService.open(IframeModalComponent, {
      size: 'xl',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.url = pdfURL;
  }
}
